var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h3',{staticClass:"block-title"},[_c('i',{staticClass:"dot left"}),_c('span',[_vm._v(_vm._s(_vm.title))]),_c('i',{staticClass:"dot right"})])
}
var staticRenderFns = []

export { render, staticRenderFns }